import type { PlantStatus } from '@/shared/data-types';

/**
 * 지표 값을 회색(비활성)으로 흐리게 처리할 발전소 상태 — 통신끊김·운영준비중(라이브 데이터 없음). 구앱 dashboard
 * 정합. 발전량/수익 리포트가 선택 발전소가 이 상태면 지표 값을 흐리게 표시(라벨·아이콘·차트·표는 정상).
 */
export function isDimmedPlantStatus(status: PlantStatus | undefined): boolean {
  return status === 'commLost' || status === 'preparing';
}

/** 흐린 지표 값 클래스(구앱 foregroundSubtle 등가) — 통신끊김/운영준비중 발전소 값 색. */
export const DIMMED_METRIC_VALUE = 'text-heviton-fg-subtle';
